/**
 * File content-hub/newsletter.js.
 * Handles logic for newsletter on Content Hub
 */

const newsletterForm = document.querySelector('.content-hub-newsletter__form');

function fireNewsletterEvent(email) {
  let properties = {
    email: email
  };

  segment(
    'track',
    'Newsletter Signup Submitted',
    properties
  );
}

function showSuccessMessage(newsletter) {
  newsletter.classList.add('content-hub-newsletter--success');
}

function validateSubmission(e) {
  e.preventDefault();
  const newsletter = e.target.closest('.content-hub-newsletter');
  const newsletterInput = e.target.querySelector('.content-hub-newsletter__input');
  const email = newsletterInput.value;
  
  if (validateEmail(email) && email !== '') {
    fireNewsletterEvent(email);
    showSuccessMessage(newsletter);
  }  
}

if (newsletterForm) {
  newsletterForm.addEventListener('submit', validateSubmission);
}
